import Vue from 'vue'
import Vuex from 'vuex'
// import permit from './modules/permit'
import user from './modules/user'
// import common from "./modules/common";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    // common,
    // permit,
    user
  }
})
